export default function (){
return(
    <>
    <h1 className="text-center mt-4 pt-4 ">Page Not Found</h1>
    </>
)
}
